import * as React from 'react';
import { styled } from '../../theme';
import PhoneInputWithCountrySelect, { Props } from 'react-phone-number-input';
import { CommonInputCss } from './inputs';

export interface FormikPhoneInputProps extends Props<{}> {
  formik: {
    handleChange: (value: string) => void;
    handleBlur: (value: string) => void;
  };
  name: string;
  placeholder?: string;
  hasError?: boolean;
}

export const FormikPhoneInput = React.forwardRef<any, FormikPhoneInputProps>((props, ref) => {
  const { name, value, onChange, hasError, ...rest } = props;
  // TODO: Filter out countries we don't want to support
  return (
    <S.StyledPhoneInput
      autoFocus={true}
      addInternationalOption={false}
      international={true}
      defaultCountry={'US'}
      {...rest}
      ref={ref}
      name={name}
      value={value}
      onChange={onChange}
      hasError={hasError ?? false}
    />
  );
});

namespace S {
  export const StyledPhoneInput = styled(PhoneInputWithCountrySelect)<{ hasError?: boolean }>`
    --PhoneInput-color--focus: ${(p) => p.theme.forms.input.background};
    --PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);
    --PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);

    & input {
      ${CommonInputCss};
      border: solid 1px ${(p) => (p.hasError ? p.theme.forms.input.error : 'transparent')};
      background: ${(p) => p.theme.forms.input.background};
      color: ${(p) => p.theme.forms.input.color};

      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px ${(p) => p.theme.forms.input.background} inset !important;
        -webkit-text-fill-color: ${(p) => p.theme.forms.input.color} !important;
      }
    }

    & select:focus {
      outline: none;
    }

    & .PhoneInputInternationalIconPhone {
      fill: ${(p) => p.theme.forms.icon.color};
    }

    & .PhoneInputInternationalIconGlobe {
      path {
        stroke: ${(p) => p.theme.forms.icon.color};
      }
      line {
        color: ${(p) => p.theme.forms.icon.color};
      }
    }
  `;
}
